module.exports = __webpack_public_path__ + "f92e80f7f3a18610e10ad134cfcfaaa6.svg";